import { render, staticRenderFns } from "./MerchantApp.vue?vue&type=template&id=0d422ae2&"
import script from "./MerchantApp.vue?vue&type=script&lang=js&"
export * from "./MerchantApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports